import React from 'react';
import styled from 'styled-components';

import { UeElement } from '@oneaudi/falcon-tools';
import type { AssetTypeImage } from '../../../types';
import { parseAssetValue } from '../../utils/parseAssetValue';
import { SYS_BORDER_RADIUS_MD } from '@oneaudi/unified-web-common';

interface ImageProps {
  asset: AssetTypeImage;
}

const ImageContainer = styled.div`
  width: 100%;

  img {
    width: 100%;
    object-fit: cover;
    border-radius: ${process.env.IS_LEGACY ? '' : SYS_BORDER_RADIUS_MD};
  }
`;

export const Image = ({ asset }: ImageProps) => {
  return (
    <ImageContainer>
      <UeElement type="media" property="assetSrc" label="Image">
        {(ueElemProps) => (
          <img
            src={asset?.src ? parseAssetValue(asset.src.assetValue).src : asset?.src?.assetValue}
            alt={asset.alt}
            {...ueElemProps}
          />
        )}
      </UeElement>
    </ImageContainer>
  );
};
